import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { AuthEventsService } from './auth/auth-events.service';
import { TolgeeService } from '@core/translation/tolgee.service';
import { authInitializer } from './auth';
import { translationInitializer } from '@core/translation/translation-initializer';
import { BcmTenantService } from '@modules/bcm/bcm-tenant.service';
import { BcmService } from '@modules/bcm/bcm.service';
import { TenantApiService } from '@bcmApiServices/tenant.api-service';
import { Location } from '@angular/common';

export function appInitializer(
    authService: AuthService,
    authEventsService: AuthEventsService,
    tolgeeService: TolgeeService,
    bcmTenantService: BcmTenantService,
    tenantApiService: TenantApiService,
    bcmService: BcmService,
    location: Location,
): () => Observable<boolean> {
    return () => {
        // first auth, then load translations!
        return authInitializer(authService, authEventsService)
            .pipe(switchMap(authSuccess => {
                if (authSuccess) {
                    return translationInitializer(
                        tolgeeService,
                        bcmTenantService,
                        tenantApiService,
                        bcmService,
                        location,
                    );
                } else {
                    return of(authSuccess);
                }
            }));
    };
}
